import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {UserService} from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private userService: UserService, private router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.userService.isLoggedIn()) {
      return true;
    }

    // Not logged in yet — wait briefly for Google auto-login to complete
    return this.userService.getUser().then(user => {
      if (user) {
        return true;
      }
      this.userService.redirectUrl = state?.url;
      this.router.navigate(['/sign-in']);
      return false;
    });
  }
}
